var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternshipsType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.688,
    height: 12.833,
    viewBox: "0 0 13.688 12.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set-Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "briefcase",
    d: "M213.7,212.844a.847.847,0,0,0-.118-.428h-1.474a.847.847,0,0,0-.118.428.856.856,0,0,0,1.711,0Zm.856,0a1.711,1.711,0,0,1-3.422,0,1.619,1.619,0,0,1,.06-.428H206v4.705a1.711,1.711,0,0,0,1.711,1.711h10.266a1.711,1.711,0,0,0,1.711-1.711v-4.705h-5.194a1.619,1.619,0,0,1,.06.428Zm0-5.133h-3.422v-.428a.428.428,0,0,1,.428-.428h2.567a.428.428,0,0,1,.428.428v.428Zm3.422,0h-2.567v-.856a.856.856,0,0,0-.856-.856h-3.422a.856.856,0,0,0-.856.856v.856h-2.567A1.711,1.711,0,0,0,206,209.422v2.139h13.688v-2.139a1.711,1.711,0,0,0-1.711-1.711Z",
    transform: "translate(-206 -206)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternshipsType);
export default __webpack_public_path__ + "static/media/internships-type.d877535aea5a65e00d7b742a504e66fe.svg";
export { ForwardRef as ReactComponent };